<template>
  <v-form class="pa-6">
    <h3 class="text-left mb-1 text-primary">Add second factors (<span v-html="serverConfig.credential.id"></span>)</h3>
    <p class="text-caption mb-4">Agregá segundos factores a la credencial creada.</p>
      <v-row>
        <v-col v-if="webAuthnSuccessful" cols="12" class="pt-3">
          <h4 class="text-left mb-4">WebAuthn (success)</h4>
        </v-col>
        <v-col v-if="serverConfig.credential.webauthn && !webAuthnSuccessful" cols="12" class="pt-3">
            <v-row>
          <h4 class="text-left mb-4">WebAuthn:</h4>
          <v-col cols="6">
              <v-text-field
                v-model="webAuthnDisplayName"
                label="Display Name"
              ></v-text-field>
                <v-text-field
                        v-model="webauthnUserPanelUrl"
                        label="WebAuth User Panel"
                ></v-text-field>
              <v-checkbox
                      class="mt-0 pt-0"
                      v-model="enableWebAuthnValidation"
                      label="Enable credential validation"
              ></v-checkbox>
          </v-col>
          <v-col cols="4">
              <v-btn
                      size="small"
                      color="primary"
                      class="ml-2"
                      @click="addWebAuthnCredential">
                  Add Credential
              </v-btn>
          </v-col>
            </v-row>
        </v-col>

        <v-col v-if="pinSuccessful" cols="12" class="pt-0">
          <h4 class="text-left mb-4">PIN (success)</h4>
        </v-col>
        <v-col v-if="serverConfig.credential.pin && !pinSuccessful" cols="12" class="pt-0">
          <h4 class="text-left mb-4">PIN:</h4>
          <div class="d-flex">
            <v-col cols="4" class="pt-0 pl-0">
              <v-text-field
                v-model="pinValue"
                label="pin"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="d-flex pt-0">
              <v-btn
                size="small"
                color="primary"
                @click="addPin"
                :disabled="pinValue == ''">
                Add pin
              </v-btn>
            </v-col>
            <v-col cols="4" class="pt-0">
            </v-col>
          </div>
          <v-col cols="4" class="pt-0 pl-0">
            <v-text-field
              v-model="pinDescription"
              label="description"
            ></v-text-field>
          </v-col>
          <v-divider></v-divider>
        </v-col>

        <v-col v-if="smsSuccess" cols="12" class="pt-0">
          <h4 class="text-left mb-4">SMS (success)</h4>
        </v-col>
        <v-col v-if="serverConfig.credential.sms && !smsSuccess" cols="12" class="pt-0">
          <h4 class="text-left mb-4">SMS:</h4>
          <div class="d-flex">
            <v-col cols="4" class="pt-0 pl-0">
              <v-text-field
                v-model="phoneNumber"
                label="Phone number"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="d-flex pt-0">
              <v-text-field
                v-model="smsMaxAttempts"
                type="number"
                label="Max Attempts"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="pt-0">
              <v-text-field
                v-model="smsExpirationSeconds"
                type="number"
                label="Expiration Seconds"
              ></v-text-field>
            </v-col>
          </div>
          <div class="d-flex">
            <v-col cols="4" class="pt-0 pl-0">
              <v-select
                v-model="smsLanguage"
                :items="['EN', 'ES']"
                label="Language"
                required
              ></v-select>
            </v-col>
            <v-col cols="4" class="pt-0">
              <v-text-field
                v-model="smsLockTimeoutSeconds"
                type="number"
                label="Lock Time Seconds"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="d-flex pt-0">

            </v-col>
          </div>
          <v-btn
            size="small"
            color="primary"
            @click="sendSMSVerificationCode"
            class="mb-8"
            :disabled="phoneNumber.length < 7 || smsLockTimeoutSeconds == '' || smsExpirationSeconds == '' || smsMaxAttempts == ''">
            Send sms
          </v-btn>
          <div class="d-flex" v-if="smsSent">
            <v-col cols="4" class="pt-0 pl-0">
              <v-text-field
                v-model="smsValue"
                label="SMS code"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="d-flex pt-0">
              <v-btn
                size="small"
                color="primary"
                @click="verifySMS"
                :disabled="smsValue == ''">
                Verify SMS
              </v-btn>
            </v-col>
            <v-col cols="4" class="pt-0">
            </v-col>
          </div>
          <v-divider></v-divider>
        </v-col>

        <v-col v-if="emailSuccess" cols="12" class="pt-0">
          <h4 class="text-left mb-4">Email (success)</h4>
        </v-col>
        <v-col v-if="serverConfig.credential.email && !emailSuccess" cols="12" class="pt-0">
          <h4 class="text-left mb-4">Email:</h4>
          <div class="d-flex">
            <v-col cols="4" class="pt-0 pl-0">
              <v-text-field
                v-model="email"
                label="email"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="d-flex pt-0">
              <v-text-field
                v-model="emailMaxAttempts"
                type="number"
                label="Max Attempts"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="pt-0">
              <v-text-field
                v-model="emailExpirationSeconds"
                type="number"
                label="Expiration Seconds"
              ></v-text-field>
            </v-col>
          </div>
          <div class="d-flex">
            <v-col cols="4" class="pt-0 pl-0">
              <v-select
                v-model="emailLanguage"
                :items="['EN', 'ES']"
                label="Language"
                required
              ></v-select>
            </v-col>
            <v-col cols="4" class="pt-0">
              <v-text-field
                v-model="emailLockTimeoutSeconds"
                type="number"
                label="Lock Time Seconds"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="d-flex pt-0">

            </v-col>
          </div>
          <v-btn
            size="small"
            color="primary"
            @click="sendEmailVerificationCode"
            class="mb-8"
            :disabled="email == '' || emailLockTimeoutSeconds == '' || emailExpirationSeconds == '' || emailMaxAttempts == ''">
            Send email
          </v-btn>
          <div class="d-flex" v-if="emailSent">
            <v-col cols="4" class="pt-0 pl-0">
              <v-text-field
                v-model="emailValue"
                label="Email code"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="d-flex pt-0">
              <v-btn
                size="small"
                color="primary"
                @click="verifyEmail"
                :disabled="emailValue == ''">
                Verify Email
              </v-btn>
            </v-col>
            <v-col cols="4" class="pt-0">
            </v-col>
          </div>
          <v-divider></v-divider>
        </v-col>

        <v-col v-if="qrSuccessful" cols="12" class="pt-0">
          <h4 class="text-left mb-4">OTP (success)</h4>
        </v-col>
        <v-col v-if="serverConfig.credential.otp && !qrSuccessful" cols="12" class="pt-0">
          <h4 class="text-left mb-4">OTP:</h4>
          <v-col cols="4" class="pt-0 pl-0">
              <div class="d-flex">
                <v-btn
                  size="small"
                  color="primary"
                  @click="generateQR">
                  Generate QR
                </v-btn>
              </div>
          </v-col>
          <v-col cols="8" class="d-flex pt-0"></v-col>
          <div class="d-flex">
            <QRGenerator :code="qrCode" :label="qrLabel"/>
          </div>
          <div v-if="qrCode != ''" class="d-flex">
            <v-col cols="4" class="pt-0 pl-0">
              <v-text-field
                v-model="qrResultCode"
                label="QR code"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="d-flex pt-0">
              <v-btn
                size="small"
                color="primary"
                @click="verifyQRCode"
                :disabled="qrResultCode == ''">
                Verify Code
              </v-btn>
            </v-col>
            <v-col cols="4" class="d-flex pt-0"></v-col>
          </div>
          <v-divider></v-divider>
        </v-col>
      </v-row>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex';
import QRGenerator from './QRGenerator';
import webAuthn from  '@/services/webAuthn.js'
import alisonServer from  '../services/alisonServer.js';
import enviroment from '../enviroment';
  export default {
    components: {
      QRGenerator
    },
    props:["data", "config", "serverConfig"],
    data: () => ({
      pinValue: '',
      pinDescription: '',
      pinSuccessful: false,
      phoneNumber: '',
      smsSent: false,
      smsLanguage: 'EN',
      smsExpirationSeconds: 90,
      smsMaxAttempts: 5,
      smsLockTimeoutSeconds: 300,
      smsValue: '',
      smsSuccess: false,
      qrCode: '',
      qrLabel: '',
      qrResultCode: '',
      qrSuccessful: false,
      email: '',
      emailValue: '',
      emailSent: false,
      emailSuccess: false,
      emailLanguage: 'EN',
      emailExpirationSeconds: 90,
      emailMaxAttempts: 5,
      emailLockTimeoutSeconds: 300,
      webAuthnDisplayName: '',
        webauthnUserPanelUrl: enviroment.webauthnUserPanelUrl,
      webAuthnSuccessful: false,
      enableWebAuthnValidation: true,
    }),
    mounted(){
      this.webAuthnDisplayName = this.serverConfig.credential.id;
    },
    watch:{

    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      async addPin() {
        try {
          await alisonServer.addPin(this.pinValue, this.pinDescription, this.serverConfig.seatId, this.serverConfig.credential.id);
          this.pinSuccessful = true;
        } catch (e) {
          this.error(e);
        }
      },

      async verifyQRCode() {
        try {
          await alisonServer.verifyQRCode(this.qrResultCode, this.serverConfig.seatId, this.serverConfig.credential.id);
          this.qrSuccessful = true;
        } catch (e) {
          this.error(e);
        }
      },

      async generateQR() {
        try {
          const { secret, user } = await alisonServer.generateQR(this.serverConfig.seatId, this.serverConfig.credential.id);
          this.qrCode = secret;
          this.qrLabel = user;
        } catch (e) {
          this.error(e);
        }
      },

      async sendSMSVerificationCode() {
        try {
          await alisonServer.assignPhoneNumber(this.phoneNumber, this.serverConfig.seatId, this.serverConfig.credential.id);
        } catch (e) {
          this.error(e);
        }
        const smsPreferences = {
          language: this.smsLanguage,
          expirationSeconds: this.smsExpirationSeconds,
          maxAttempts: this.smsMaxAttempts,
          lockTimeoutSeconds: this.smsLockTimeoutSeconds
        }
        try {
          await alisonServer.sendSMSCode(smsPreferences, this.serverConfig.seatId, this.serverConfig.credential.id);
          this.smsSent = true;
        } catch (e) {
          this.error(e);
        }
      },

      async sendEmailVerificationCode() {
        try {
          await alisonServer.assignEmail(this.email, this.serverConfig.seatId, this.serverConfig.credential.id);
        } catch (e) {
          this.error(e);
        }
        const emailPreferences = {
          language: this.emailLanguage,
          expirationSeconds: this.emailExpirationSeconds,
          maxAttempts: this.emailMaxAttempts,
          lockTimeoutSeconds: this.emailLockTimeoutSeconds
        }
        try {
          await alisonServer.sendEmailVerificationCode(emailPreferences, this.serverConfig.seatId, this.serverConfig.credential.id);
          this.emailSent = true;
        } catch (e) {
          this.error(e);
        }
      },

      async verifyEmail() {
        try {
          await alisonServer.verifyEmail(this.emailValue, this.serverConfig.seatId, this.serverConfig.credential.id);
          this.emailSuccess = true;
        } catch (e) {
          this.error(e);
        }
      },

      async verifySMS() {
        try {
          await alisonServer.verifySMS(this.smsValue, this.serverConfig.seatId, this.serverConfig.credential.id);
          this.smsSuccess = true;
        } catch (e) {
          this.error(e);
        }
      },

      async addWebAuthnCredential() {
        const seatId = this.serverConfig.seatId;
        const credentialId = this.serverConfig.credential.id;
        const url = `${this.webauthnUserPanelUrl}/${alisonServer.tenant}/webauthn/creation?`;
        const domain = window.location.protocol + "//" + window.location.hostname;
        const params = `seatId=${seatId}&credentialId=${credentialId}&token=${alisonServer.generationToken}&domain=${domain}`;
        let screenWidth = window.innerWidth;
        let screenHeight = window.innerHeight;
        let left = (screenWidth/2);
        let top = (screenHeight/2);
        let options = '';

        options += 'toolbar=no,location=no,directories=no,status=no';
        options += ',menubar=no,scrollbars=no,resizable=no,copyhistory=no';

        options += ',width='  + left;
        options += ',height=' + top;
        options += ',top='    + top;
        options += ',left='   + left;

        let newWindow = window.open(url + params,"create credential", options);
        window.addEventListener("message", function(e) {
          if (e.origin == domain)
            if (e.data.success) {
              onCreateCredential();
            }
        }, false);
        window.onWebauthnCredentialComplete = (data) => {
          if (data.success)
            this.webAuthnSuccessful = true
        }
        if (window.focus)
          newWindow.focus();
      },

      error(e) {
        this.setColor("error");
        this.setSnack(e);
        console.log(e);
      }
    },
  }
</script>
